<template>
  <div
    class="skeleton-list"
    :class="[`skeleton-list--${variant}`, 'skeleton-effect-fade']"
    aria-hidden="true"
  >
    <div v-for="n in rows" :key="n" class="skeleton-item">
      <template v-if="variant === 'row'">
        <span class="skeleton-avatar skeleton-row-avatar" />
        <div class="skeleton-item-lines">
          <span class="skeleton-text skeleton-line skeleton-line--title" />
          <span class="skeleton-text skeleton-line skeleton-line--sub" />
        </div>
      </template>
      <template v-else-if="variant === 'campaign'">
        <span class="skeleton-image skeleton-campaign-thumb" />
        <div class="skeleton-item-lines">
          <span class="skeleton-text skeleton-line skeleton-line--title" />
          <span class="skeleton-text skeleton-line skeleton-line--sub" />
          <span class="skeleton-block skeleton-progress" />
        </div>
      </template>
      <template v-else>
        <span class="skeleton-avatar skeleton-card-avatar" />
        <div class="skeleton-item-lines">
          <span class="skeleton-text skeleton-line skeleton-line--title" />
          <span class="skeleton-text skeleton-line skeleton-line--sub" />
          <span class="skeleton-text skeleton-line skeleton-line--body" />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
defineProps({
  rows: { type: Number, default: 3 },
  variant: {
    type: String,
    default: "card",
    validator: (v) => ["card", "row", "campaign"].includes(v),
  },
});
</script>

<style scoped>
.skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 16px;
}
.skeleton-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border-radius: 16px;
  background: var(--f7-card-bg-color, #fff);
}
.skeleton-list--row .skeleton-item {
  border-radius: 0;
  padding: 10px 0;
  background: transparent;
}
.skeleton-item-lines {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.skeleton-line--title {
  width: 55%;
  height: 14px;
}
.skeleton-line--sub {
  width: 38%;
  height: 12px;
}
.skeleton-line--body {
  width: 85%;
  height: 12px;
}
.skeleton-row-avatar,
.skeleton-card-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
}
.skeleton-card-avatar {
  width: 44px;
  height: 44px;
}
.skeleton-campaign-thumb {
  width: 96px;
  height: 72px;
  border-radius: 12px;
  flex-shrink: 0;
}
.skeleton-progress {
  width: 60%;
  height: 8px;
  border-radius: 4px;
  margin-top: 2px;
}
@media (min-width: 1200px) {
  .skeleton-list {
    padding: 8px 0;
  }
}
</style>
